import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from "vue-router";
import FavoriteBusStopRow from "./FavoriteBusStopRow.vue";
import NoFavoriteCard from "./NoFavoriteCard.vue";
import { RouterName } from "@/types";
import { PropType } from "vue";
import { IFavoriteBusStop } from "@/domain/entities/favoriteBusStop";
import InlineSvg from "vue-inline-svg";


const __default__ = {
  name: "FavoriteBusStopList",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  favoriteBusStops: {
    type: Array as PropType<IFavoriteBusStop[]>,
    default: () => [],
  },
},
  emits: ["onSuccessRemoveFavoriteBusStop"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;

const emitOnSuccessRemoveFavoriteBusStop = (busStopId: string) => {
  emit("onSuccessRemoveFavoriteBusStop", busStopId);
};

const router = useRouter();

const goToMapOfNearbyBusStops = () => {
  router.push({ name: RouterName.MapOfNearbyBusStops });
};

const __returned__ = { emit, emitOnSuccessRemoveFavoriteBusStop, router, goToMapOfNearbyBusStops, FavoriteBusStopRow, NoFavoriteCard, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})